import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { http } from "../lib/api";
import { formatDate } from "../lib/posts";
import { useTitle } from "../lib/useTitle";
import { LatestNews } from "../components/news/LatestNews";

export default function NewsPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  useTitle(post ? `${post.title} | Gait Naurish Ltd.` : "News & Insights | Gait Naurish Ltd.");

  useEffect(() => {
    let alive = true;
    setPost(null);
    http.get(`/posts/${slug}`)
      .then((r) => { if (alive) setPost(r.data); })
      .catch(() => { if (alive) setPost(false); });
    return () => { alive = false; };
  }, [slug]);

  if (post === null) return <main className="min-h-screen grid place-items-center"><Loader2 className="animate-spin text-[var(--moss)]" /></main>;
  if (post === false) {
    return (
      <main className="min-h-[70vh] pt-48 mx-auto max-w-3xl px-5" data-testid="news-not-found">
        <h1 className="font-display text-4xl text-[var(--forest)]">Article not found</h1>
        <Link to="/news" className="mt-6 inline-flex items-center gap-2 font-bold text-[var(--moss)]"><ArrowLeft size={16} /> All insights</Link>
      </main>
    );
  }

  return (
    <main data-testid="news-post-page">
      <article>
        <header className="pt-40 md:pt-48 pb-10 mx-auto max-w-3xl px-5">
          <Link to="/news" data-testid="news-back-link" className="inline-flex items-center gap-2 text-sm font-semibold text-[var(--muted)] hover:text-[var(--forest)]"><ArrowLeft size={15} /> All insights</Link>
          <p className="mt-8 text-[13px] font-bold uppercase tracking-[0.2em] text-[var(--leaf)]">{post.category} · {formatDate(post.published_at)}</p>
          <h1 data-testid="news-post-title" className="font-display text-3xl sm:text-5xl text-[var(--forest)] mt-4 leading-[1.08]">{post.title}</h1>
          <p className="mt-6 text-lg md:text-xl text-[var(--muted)] leading-relaxed">{post.summary}</p>
        </header>
        {post.cover && (
          <div className="mx-auto max-w-5xl px-5">
            <div className="aspect-[16/9] overflow-hidden rounded-[10px] bg-[var(--paper)]">
              <img src={post.cover} alt={post.title} className="h-full w-full object-cover" />
            </div>
          </div>
        )}
        <div data-testid="news-post-body" className="mx-auto max-w-3xl px-5 py-12 md:py-16 space-y-5 text-base md:text-lg leading-relaxed text-[var(--ink)]">
          {post.body.split(/\n\s*\n/).map((para, i) => <p key={i} className="whitespace-pre-line">{para}</p>)}
        </div>
      </article>
      <div className="border-t border-[var(--line)]"><LatestNews /></div>
    </main>
  );
}
